import axios from "./api";

// 初始化协议
export const getCancellationInfo = params => {
  return axios({
    url: "/v2/cs/closeAccountInit",
    loading: true,
    params
  });
};

// 获取账号状态
export const getAccountStatus = data => {
  return axios({
    url: "/v2/cs/accountStatus",
    method: "post",
    loading: true,
    data,
    silent: [3001]
  });
};

// 提交注销申请
export const doCancellation = data => {
  return axios({
    url: "/v2/cs/confirmInformation",
    method: "post",
    loading: true,
    data
  });
};
